import React, { Component } from 'react';
import reqwest from 'reqwest';
import ReactTable from 'react-table';

import settings from '../../../../../../settings';
import ContentBox from '../../../../../components/FormArea/ContentBox';
import Button from '../../../../../components/Button';
import RightSide from '../../../../../components/FormArea/RightSide';
import Loader from '../../../../../components/Loader';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

class AppearanceOverview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appearances: [],
      loading: true,
    };

    reqwest({
      method: 'get',
      url: settings.franchise.appearance.getList,
      contentType: 'json',
      data: {
        Token: localStorage.getItem('token'),
        FranGuid: this.props.franchiseGuid,
      },
    }).then(appearanceResponse => {
      const appearances = JSON.parse(appearanceResponse);
      this.setState({
        appearances,
        loading: false,
      });
    });
  }

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    const data = this.state.appearances.filter(row => row.Guid);

    return (
      <>
        <div className='FormArea-Form-Left'>
          <ContentBox title='Erscheinungsbild'>
            <ReactTable
              getTrProps={(_, { original }) => ({
                onClick: () => this.props.history.replace(`${this.props.match.url}/${original.Guid}`),
              })}
              data={data}
              pageSize={data.length}
              noDataText='Es liegt kein Erscheinungsbild für das ausgewählte Büro vor.'
              defaultSorted={[
                {
                  id: 'FirstShowcase',
                  desc: false,
                },
              ]}
              columns={[
                {
                  Header: 'Erstschaufenster',
                  accessor: 'FirstShowcase',
                  Cell: ({ value }) => (value === 'true' ? 'Ja' : 'false'),
                },
                {
                  Header: 'Zweitschaufenster',
                  accessor: 'SecondShowcase',
                  Cell: ({ value }) => (value === 'true' ? 'Ja' : 'false'),
                },
                {
                  Header: 'Anzahl Schaufenster',
                  accessor: 'CountShowcase',
                },
              ]}
            />
          </ContentBox>
        </div>
        <RightSide>
          <Button big icon={faPlus} to={`${this.props.match.url}/new`} replace>
            Neues Erscheinungsbild
          </Button>
        </RightSide>
      </>
    );
  }
}

export default AppearanceOverview;
